import React from "react";

const SolarSolutions = () => {
  return (
    <div className="">
      {/* <div className="min-h-screen relative top-28"> */}
      SolarSolutions
    </div>
  );
};

export default SolarSolutions;
